import axios from "axios";
import { MAIN_URL } from "../../../API/Api";

const GetAllSunlightRates = async (token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    let response = await axios({
        method: "GET",
        baseURL: `${MAIN_URL}/sunlight/rates`,
        headers: headers,
    });
    return response.data;
};

const CreateNewSunlightRate = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    let response = await axios({
        method: "POST",
        baseURL: `${MAIN_URL}/admin/sunlight/rates/create`,
        headers: headers,
        data: data  
    });
    return response.data;
};
const SunlightRatesService = {
    GetAllSunlightRates,
    CreateNewSunlightRate
};

export default SunlightRatesService;
